import { render, staticRenderFns } from "./PopularRecipes.vue?vue&type=template&id=4c287791&scoped=true&"
import script from "./PopularRecipes.vue?vue&type=script&lang=js&"
export * from "./PopularRecipes.vue?vue&type=script&lang=js&"
import style0 from "./PopularRecipes.vue?vue&type=style&index=0&id=4c287791&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c287791",
  null
  
)

export default component.exports